// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RichText_wrapper__U5VKw"};